import React, { useState, useEffect } from 'react'
import { oneKlicks } from '../../SDK/oneclick';
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav, Space, Input, Select, Card, Alert, Spinner } from "react-bootstrap";



const UserVerificationRequest = () => {
  const [userVerificationRequest, setUserVerificationRequest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getUserVerificationRequest();
  }, []);

  const getUserVerificationRequest = async () => {
    try {
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            is_verified: "pending"
        };
        const orderBy = "id DESC";
        const search = {};
        const pagination = { page: 1, limit: 10 };
        const margedata = [];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        if (response.success && response.data.length > 0) {
            setUserVerificationRequest(response.data);
        } else {
            setUserVerificationRequest([]);
        }
    } catch (error) {
      console.error('Error fetching user verification request:', error);
      setUserVerificationRequest([]);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">User Verification Request</h5>
                                <Badge bg="info">Management</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Verification Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                <Spinner animation="border" variant="primary" />
                                            </td>
                                        </tr>
                                    ) : (
                                        userVerificationRequest.length > 0 ? (
                                        userVerificationRequest.map((user) => (
                                            <tr key={user.id}>
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.phone}</td>
                                                <td>{user.verification_status}</td>
                                                <td>{user.action}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">No data found</td>
                                        </tr>
                                    ))}
                                    
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
};

export default UserVerificationRequest
